<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 align-self-center text-left px-10 pb-6>
        <span class="headds">My Orders</span>
      </v-flex>
      <v-flex xs12 px-6>
        <v-layout wrap>
          <v-flex xs12 sm6 md3 px-4>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  label="From Date"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="fromDate"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3 px-4>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  label="To Date"
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="toDate"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md12 v-if="myOrders && totalCount > 0">
        <v-layout wrap pb-3>
          <v-flex sm6 md3 v-for="(item, i) in myOrders" :key="i">
            <v-card
              height="300px"
              py-4
              flat
              :to="'OrderInfo?order=' + item._id"
            >
              <v-layout wrap justify-center text-center px-10>
                <v-flex xs12 pb-2 v-if="item.photos.length > 0">
                  <v-card height="200" tile flat>
                    <div style="margin: 0; height: 100%">
                      <Collage
                        :images="item.photos"
                        :collageSizeMin="1"
                        :collageSizeMax="4"
                        :showNoImagesMsg="true"
                        noImagesMsg="No Images"
                        :showLoadingMsg="false"
                        loadingMsg="Loading..."
                        height="200px"
                      >
                      </Collage>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12 pb-2 v-else>
                  <v-img
                    height="200"
                    contain
                    :src="require('./../../../assets/images/no-image.png')"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color=" #FDAC53"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12>
                      <span
                        v-for="(items, index) in item.products"
                        :key="index"
                        style="font-family: poppinsregular; font-size: 14px"
                      >
                        <span v-if="index <= 1">
                          {{ items.name }}
                          <span v-if="index < item.products.length - 1">,</span>
                        </span>
                      </span>
                      <span v-if="item.products.length > 2">...</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 pt-1>
                  <span style="font-weight: bold">
                    Rs. {{ item.totalAmount }}
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-left v-else>
        <span class="">No Orders Found!!!</span>
      </v-flex>
    </v-layout>
     <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import Collage from "vue-collage";
export default {
  components: {
    Collage,
  },
  data() {
    return {
      currentPage: 1,
      myOrders: [],
      pages: 0,
      totalCount: 0,
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      fromDate: null,
      toDate: null,
      menu1: false,
      menu2: false,
    };
  },
  watch: {
    currentPage() {
      this.getProduct();
    },
    fromDate() {
      // if (this.fromDate == null)

      this.getProduct();
    },
    toDate() {
      if (this.fromDate != null) this.getProduct();
    },
  },
  beforeMount() {
    if (this.$route.query.customer) {
      this.getProduct();
    }
    if (this.fromDate) {
      this.fromDate.setDate(this.fromDate.getDate());
      this.fromDate = this.fromDate.toISOString().substr(0, 10);
    }
    if (this.toDate) {
      this.toDate.setDate(this.toDate.getDate());
      this.toDate = this.toDate.toISOString().substr(0, 10);
    }
  },

  methods: {
    getProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          uid: this.$route.query.customer,
          from: this.fromDate,
          to: this.toDate,
          page: this.currentPage,
        },
      })
        .then((response) => {
          if (response.data.status) {
            var myOrders = [];
            myOrders = response.data.data;
            var vm = this;
            for (var i = 0; i < myOrders.length; i++) {
              if (myOrders[i].photos.length > 0) {
                var photos = [];
                photos = myOrders[i].photos;
                photos.map(function (obj) {
                  obj.image = vm.mediaURL + obj.image;
                  return obj;
                });
                myOrders[i].photos = photos;
              }
            }
            this.myOrders = myOrders;
            this.totalCount = response.data.totalLength;
            this.pages = response.data.totalPages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
